<template>
  <el-table
    :data="list"
    style="width: 100%"
    tooltip-effect="light">
    <el-table-column
      type="index"
      label="排序"
      width="50px">
    </el-table-column>
    <el-table-column
      label="操作"
      width="80px"
      v-if="type === 'dialog'">
      <template slot-scope="scope">
        <el-button v-if="type === 'dialog'" @click="handleChoose(scope.row)">选择</el-button>
      </template>
    </el-table-column>
    <template v-for="(col, index) in columns">
      <el-table-column
        :key="index"
        :prop="col.prop"
        :label="col.label"
        :show-overflow-tooltip="col.showOverflowTooltip">
        <template v-slot="scope">
          <template v-if="col.render">
            <!-- 渲染函数组件 -->
            <render-cell
              :render="col.render"
              :row="scope.row"
              :index="scope.$index"
            />
          </template>
          <span v-else>{{ scope.row[col.prop] }}</span>
        </template>
      </el-table-column>
    </template>
    <el-table-column
      label="操作"
      width="180px"
      v-if="type === 'list'">
      <template slot-scope="scope">
        <el-button v-if="type === 'list'" @click="handleLook(scope.row)" v-permission="'0300101'">查看</el-button>
        <el-button v-if="type === 'list'" @click="handleHistoryVersion(scope.row)" v-permission="'0300102'">历史版本</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
const RenderCell = {
  functional: true,
  props: ['render', 'row', 'index'],
  render: (h, ctx) => {
    return ctx.props.render(h, ctx.props.row, ctx.props.index)
  }
}
export default {
  name: 'comTable',
  components: { RenderCell },
  props: {
    list: {
      required: true,
      type: Array
    },
    columns: {
      required: true,
      type: Array
    },
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    handleLook (row) {
      this.$emit('look', row)
    },
    handleHistoryVersion (row) {
      this.$emit('historyVersion', row)
    },
    handleChoose (row) {
      this.$emit('choose', row)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
